<template>
  <em
    v-if="!isLink"
    id="copy-button"
    class="qx-icon icon-copy"
    role="button"
    :title="title"
    @click="copyAction" />
  <a
    v-else
    class="action-link copy-path"
    role="button"
    :title="title"
    @click="copyAction">
    <em
      id="copy-button"
      class="qx-icon icon-copy mr-1" />
    <span>{{ string.actualLinkTitle }}</span>
  </a>
</template>

<script>
import { copyToClipboard } from '@/elements/utils.js';

export default {
  name: 'CopyButton',
  props: {
    stringToCopy: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: null,
    },
    isLink: {
      type: Boolean,
      default: false,
    },
    linkTitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    string() {
      return {
        actualLinkTitle: this.linkTitle?.length > 0 ? this.linkTitle : this.$gettext('Copy path'),
      };
    },
  },
  methods: {
    copyAction() {
      if (this.stringToCopy?.length > 0) {
        copyToClipboard(this.stringToCopy, this.successMessage);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#copy-button {
  margin-left: 5px;
  font-size: 20px;
  color: $gray-700;
  &:active {
    color: $gray-900;
  }
}
</style>
